{
  "directional4": [
    [[0, 0], [1, 0], [0.5, 0.5]],
    [[1, 0], [1, 1], [0.5, 0.5]],
    [[1, 1], [0, 1], [0.5, 0.5]],
    [[0, 1], [0, 0], [0.5, 0.5]]
  ],
  "single": [
    [[0, 0], [1, 0], [1, 1], [0, 1]]
  ],
  "rows2": [
    [[0, 0], [1, 0], [1, 0.5], [0, 0.5]],
    [[0, 0.5], [1, 0.5], [1, 1], [0, 1]]
  ],
  "rows3": [
    [[0, 0], [1, 0], [1, 0.3333333333], [0, 0.3333333333]],
    [[0, 0.3333333333], [1, 0.3333333333], [1, 0.6666666667], [0, 0.6666666667]],
    [[0, 0.6666666667], [1, 0.6666666667], [1, 1], [0, 1]]
  ],
  "grid4": [
    [[0, 0], [0.5, 0], [0.5, 0.5], [0, 0.5]],
    [[0.5, 0], [1, 0], [1, 0.5], [0.5, 0.5]],
    [[0, 0.5], [0.5, 0.5], [0.5, 1], [0, 1]],
    [[0.5, 0.5], [1, 0.5], [1, 1], [0.5, 1]]
  ]
}
